export default __webpack_public_path__ + "static/media/junglelandscape.2efb9c80.jpg";